import styled from 'styled-components';

export default styled.div`
  margin-bottom: 1.5em;
  text-align: center;
  position: relative;
  display: block;

  h2 {
    margin-bottom: 0.75em;
    color: rgb(0 0 0);
    line-height: 1;
  }

  p {
    color: rgb(34 34 34);
    position: relative;

    line-height: 1.2;
    font-size: 1rem;
    display: block;

    width: 100%;
    margin: 0;
  }
`;
